import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import AccessibilityRouteSupport from "./components/AccessibilityRouteSupport";
import BenefitsAccess from "./pages/InfoAccess/BenefitsAccess";
import InfoAccess from "./pages/InfoAccess/InfoAccess";
import VerifyEmailToken from "./pages/Auth/VerifyEmailToken";
import { getBenefitsConversationId, hasBenefitsSession } from "./utils/benefitsSession";

const BenefitsChatIndexRoute = () =>
  hasBenefitsSession() ? (
    <Navigate to={`/chat/${getBenefitsConversationId()}`} replace />
  ) : (
    <Navigate to="/start" replace />
  );

const BenefitsChatRoute = () =>
  hasBenefitsSession() ? <InfoAccess /> : <Navigate to="/start" replace />;

const BenefitsEntryRoute = () =>
  hasBenefitsSession() ? <Navigate to="/chat" replace /> : <BenefitsAccess />;

const LegacyBenefitsChatRoute = () => {
  const { conversationId = "" } = useParams();
  return <Navigate to={`/chat/${conversationId}`} replace />;
};

function App() {
  return (
    <BrowserRouter>
      <AccessibilityRouteSupport />
      <Routes>
        <Route path="/" element={<BenefitsChatIndexRoute />} />
        <Route path="/start" element={<BenefitsEntryRoute />} />
        <Route path="/verify-email" element={<VerifyEmailToken />} />
        <Route path="/benefits" element={<BenefitsChatIndexRoute />} />
        <Route path="/chat" element={<BenefitsChatIndexRoute />} />
        <Route path="/chat/:conversationId" element={<BenefitsChatRoute />} />
        <Route path="/benefits/chat" element={<Navigate to="/chat" replace />} />
        <Route path="/benefits/chat/:conversationId" element={<LegacyBenefitsChatRoute />} />
        <Route path="*" element={<Navigate to="/start" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
